import { useField } from 'formik'
import React from 'react'
import { Form, InputGroup } from 'react-bootstrap'
import styled from 'styled-components'
import { FormGroup } from 'components'
import { _, colors } from 'utils'
import { TextFieldProps } from '../types'

const S = {
    FormGroup: styled(FormGroup)`
        position: relative;
        & textarea::placeholder {
            font-size: 14px;
            color: ${colors.grayTitle};
            opacity: 0.5;
        }
    `,
    NumberActions: styled.div<{ isDisabled?: boolean }>`
        position: absolute;
        height: 44px;
        width: 30px;
        top: 26px;
        right: 10px;
        border-left: 1px solid ${colors.inputBorder};
        pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'auto')};
        & > div {
            height: 22px;
            font-weight: bold;
            line-height: 21px;
            text-align: center;
            color: ${colors.grayTitle};
            border-bottom: 1px solid ${colors.inputBorder};
            opacity: 0.9;
            cursor: pointer;
            user-select: none;
        }
        & > div:last-child {
            border-bottom: none;
            line-height: 18px;
            transform: scaleX(1.5);
        }
    `,
    LabelWrapper: styled.div`
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 26px;
    `,
}

const NumberField = ({
    name,
    label,
    helperText,
    isRequired,
    placeholder = '',
    isDisabled,
    isReadOnly,
    ...props
}: TextFieldProps) => {
    const [
        field,
        meta,
        helper
    ] = useField({ name })
    const { error, touched } = meta

    const preventEnteringNonNumeric = (evt) => {
        // Only allow number, delete, backspace and arrows button
        if (evt.key.search(/[0-9]/) >= 0 || [8, 37, 38, 39, 40, 46].includes(evt.keyCode)) return
        evt.preventDefault()
    }

    return (
        <S.FormGroup
            controlId={`${field.name}-text-field`}
            {...props}
        >
            <S.LabelWrapper>
                <Form.Label className={isDisabled ? 'disabled-label' : ''}>
                    {label}
                    {isRequired && <span>&nbsp;*</span>}
                </Form.Label>
            </S.LabelWrapper>
            <InputGroup>
                <Form.Control
                    placeholder={placeholder}
                    isInvalid={touched && !!error}
                    disabled={isDisabled}
                    readOnly={isReadOnly}
                    type="number"
                    {...field}
                    onKeyDown={preventEnteringNonNumeric}
                />
            </InputGroup>

            <S.NumberActions isDisabled={isDisabled}>
                <div onClick={() => helper.setValue(+field.value + 1)}>+</div>
                <div onClick={() => helper.setValue(field.value - 1)}>-</div>
            </S.NumberActions>

            {!(touched && error) && <Form.Text muted>{helperText}</Form.Text>}

            {touched && error && (
                <small className="text-danger invalid-field">
                    {_(error)}
                </small>
            )}
        </S.FormGroup>
    )
}

export default NumberField
